import { render } from "./Index.vue?vue&type=template&id=8cb9b5d0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=8cb9b5d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8cb9b5d0"

export default script